export interface PartyVisitsYears {
  years: number[];
}

export enum VisitStatus {
  PENDING = 'Pending',
  CHECKED_IN = 'Checked In',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}
